import { createContext, ReactNode } from 'react';

export type HomepageEditorContextValue = {
  isMobile: boolean;
};

export const HomepageEditorContext = createContext<HomepageEditorContextValue>({
  isMobile: false,
});

type HomepageEditorProviderProps = HomepageEditorContextValue & {
  children?: ReactNode;
};

export const HomepageEditorContextProvider = ({
  children,
  ...props
}: HomepageEditorProviderProps) => (
  <HomepageEditorContext.Provider value={props}>
    {children}
  </HomepageEditorContext.Provider>
);
